import { MatSort } from '@angular/material/sort';
import {
  SaleBreezeUpModel,
  SaleSessionModel,
} from 'src/app/models/sales/sale-settings.model';
import { MatDataSource } from 'src/app/shared-new/util/mat-datasource';

class SearchModel {
  saleName: string;
  horseName: string;
  lot: string;
  accession: string;
  vet: string;
  status: string;
}

export class DatasourceModel {
  startDate: Date;
  minLotNumber: number;
  maxLotNumber: number;
  breezeMinLotNumber: number;
  breezeMaxLotNumber: number;
  bookNumber: number;
  sessionNumber: number;
  breezeDate: Date;
  xrayScopeTaken: Date;
  xrayScopeVisible: Date;
  breezeups: DatasourceModel[];

  static fromBreezeUp(
    data: SaleBreezeUpModel,
    minLotNumber: number,
    maxLotNumber: number
  ): DatasourceModel {
    return {
      startDate: new Date(data?.saleDateTime),
      minLotNumber: minLotNumber || null,
      maxLotNumber: maxLotNumber || null,
      bookNumber: data?.bookNumber || null,
      sessionNumber: data?.sessionNumber || null,
      breezeDate: new Date(data?.breezeDateTime),
      xrayScopeTaken: data?.xrayScopeTaken
        ? new Date(data.xrayScopeTaken)
        : null,
      xrayScopeVisible: data?.xrayScopeVisible
        ? new Date(data.xrayScopeVisible)
        : null,
      breezeMinLotNumber: data?.minLotNumber || null,
      breezeMaxLotNumber: data?.maxLotNumber || null,
      breezeups: [],
    };
  }
  constructor(data: SaleSessionModel, breezeUps: DatasourceModel[]) {
    this.startDate = data?.startDate ? new Date(data.startDate) : null;
    this.minLotNumber = data?.minLotNumber || null;
    this.maxLotNumber = data?.maxLotNumber || null;
    this.bookNumber = data?.bookNumber || null;
    this.sessionNumber = data?.sessionNumber || null;
    this.breezeDate = data?.breezeDate ? new Date(data.breezeDate) : null;
    this.xrayScopeTaken = data?.xrayScopeTaken
      ? new Date(data.xrayScopeTaken)
      : null;
    this.xrayScopeVisible = data?.xrayScopeVisible
      ? new Date(data.xrayScopeVisible)
      : null;
    this.breezeups = breezeUps;
  }
}

export class DeadlinesDataSource extends MatDataSource<DatasourceModel> {
  public constructor(data: DatasourceModel[], sort: MatSort) {
    super(data, sort);
    this.setFilterPredicate();
    this.setCustomSort();
  }

  private sortOn: string;

  public setSortOn(sortOn: string) {
    this.sortOn = sortOn;
  }

  setFilterPredicate(): void {
    // this.filterPredicate = (
    //   submission: SaleSessionModel,
    //   filterValue: string = ''
    // ) => {
    //   const model: SearchModel = {
    //     saleName: submission.sale.saleName,
    //     horseName: submission.saleHorse.horseName,
    //     lot: submission.lot.toString(),
    //     accession: submission.saleHorse.accessionCode,
    //     vet: submission.vetName,
    //     status: submission.status,
    //   };
    //   return 'saleName,horseName,lot,accession,vet,status'
    //     .split(',')
    //     .some((key) => {
    //       return (
    //         model[key as keyof SearchModel] &&
    //         new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
    //           model[key as keyof SearchModel]
    //         )
    //       );
    //     });
    // };
  }

  // Custom sort method for a specific column (e.g., 'horseName')
  setCustomSort(): void {
    // this.sortingDataAccessor = (
    //   submission: SubmissionModel,
    //   sortHeaderId: string
    // ): any => {
    //   if (sortHeaderId === 'accession') {
    //     return submission.saleHorse.accessionCode?.toLowerCase();
    //   }
    //   if (sortHeaderId === 'sale') {
    //     return submission.sale.saleName?.toLowerCase();
    //   }
    //   if (sortHeaderId === 'horse') {
    //     return submission.saleHorse.horseName?.toLowerCase();
    //   }
    //   // Default sorting for other columns
    //   return submission[sortHeaderId as keyof SubmissionModel];
    // };
  }
}
